// extracted by mini-css-extract-plugin
export var personRow = "index-module--personRow--1BgT9";